import { render, staticRenderFns } from "./MovementScannerUnload.vue?vue&type=template&id=70d6559c"
import script from "./MovementScannerUnload.vue?vue&type=script&lang=js"
export * from "./MovementScannerUnload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports